module.exports = __webpack_public_path__ + "img/Xiaoying Tang.07592dd6.png";